export default "__VITE_ASSET__BVk_Ie4c__"